import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { Observable } from "rxjs";
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "../../_Lms/services/lms.service";
import { Router } from "@angular/router";
declare var $: any;
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { DialogService } from "../../Shared/dialog.service";
import { map, startWith } from "rxjs/operators";
import { ToWords } from "to-words";
import { MasterService } from "../../Shared/app.Masters.Service";
import * as moment from "moment";
import { ActivatedRoute, Params } from "@angular/router";
import { ReportsService } from "../../_Reports/services/reports.service";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { FlatTreeControl } from "@angular/cdk/tree";

// Excel export code start here
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { constantUrl } from "src/app/Shared/constantUrl";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DatePipe } from "@angular/common";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";


@Component({
  selector: "app-accounting-statement",
  templateUrl: "./accounting-statement.component.html",
  styleUrls: ["./accounting-statement.component.scss"],
})
export class AccountingStatementComponent implements OnInit {
  chhead: any = "";
  showSpinner: boolean = false;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  loading: boolean = false;
  SelectBranch: any = "All";

  FileCheckingList: any[] = [];
  dataSource: any;
  dataSourceExcel: any;
  VoucherDateFrom: any;
  VoucherDateTo: any;
  BranchId: any = 0;
  HiddenContent: boolean = false;
  Cur_Date: any = new Date();
  BranchesList: any = [];

  AccountHead: any;
  AccountHeadName: any;
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;

  ShowDelete: boolean = false;
  AccountHeadDropdown: any[] = [];

  displayedColumns: string[] = [
    "voucherid",
    "VoucherDate",
    "Voucher_No",
    "CaseNo",
    "accHead",
    "TranType",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Narration",
    "Reference_No",
    "ViewAction",
  ];
  displayedColumnsModel: string[] = [
    "voucherid",
    "VoucherDate",
    "Voucher_No",
    "CaseNo",
    "accHead",
    "TranType",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Narration",
    "Reference_No",
    "ViewAction",
  ];
  displayedColumnsExport: string[] = [
    "voucherid",
    "VoucherDate",
    "Voucher_No",
    "CaseNo",
    "accHead",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Narration",
    "Reference_No"
  ];
  getFileName = (name: string) => {
    let timeSpan = new Date().toISOString();
    let sheetName = name || "ExportResult";
    let fileName = `${sheetName}-${timeSpan}`;
    return {
      sheetName,
      fileName,
    };
  };

  dataSourceMonthly: any;
  dataSourceDaily: any;
  dataSourceModel: any;
  exportRows: any[] = [];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("Paginglist", { read: MatPaginator }) Paginglist: MatPaginator;

  groupList: any[] = [];
  groupDropdown: any[] = [];
  BankList: any[] = [];
  groupModel: any = {};
  dropdownSettings: any = {};
  myForm: UntypedFormGroup;
  AccountControl = new UntypedFormControl();
  disabled = false;
  totalCalculator: any;
  ShowFilter = true;
  accountTagDropdown: any[] = [];
  chargesHeadDropdown: any[] = [];
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  filteredAccountHead: Observable<any[]>;
  displayedLoanColumns: string[] = [
    "Type",
    "CaseNo",
    "Customer",
    "Branch",
    "Category",
    "AccountHead",
    "AmountDR",
    "AmountCR",
  ];
  displayedAccountingColumns: string[] = [
    "AccountHead",
    "Branch",
    "AmountDR",
    "AmountCR",
  ];
  limitSelection = false;
  FyearId: any;
  maxDate: any;
  minDate: any;

  TotRow: any = 50;
  BalanceType: any = 0;

  displayedColumnsMonthly: string[] = [
    "Id",
    "Month_Year",
    "Account_Name",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Action",
  ];
  displayedColumnsDaily: string[] = [
    "Id",
    "Voucher_Date",
    "Account_Name",
    "TranTypeDR",
    "TranTypeCR",
    "TranTypeTotal",
    "Action",
  ];
  x: any;
  AccountAddress: any;
  voucherTree: any[] = []; // nodes grouped by voucher
  displayRows: any[] = []; // flat array used by template
  ExpandBtn: boolean = true;
  CollaspeBtn: boolean = false;
  modalTree: any[] | null = null;


  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private router: Router,
    private route: ActivatedRoute,
    private lmsService: LmsService,
    private reportsService: ReportsService,
    private dialog: DialogService,
    private fb: UntypedFormBuilder,
    private _commonfunctions: CommonFunctions
  ) { }
  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Accounting Statement");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getAccounthead();
    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      //console.log("paran", this.FyearId);
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
          this.VoucherDateFrom = new Date(
            moment(res[0].fystart).format("MM/DD/YYYY")
          );
          if (this.maxDate > new Date() && this.minDate < new Date())
            this.VoucherDateTo = new Date();
          else this.VoucherDateTo = this.maxDate;
          this.dataSource = null;
        });
    });
    // this.getBranchesList();

  }

  onAccountHeadhSelect(event: any) {
    this.AccountHead = event.option.value.AccountId;
    this.AccountHeadName = event.option.value.Account_Name;
    this.AccountAddress = event.option.value.Acc_Address;
  }
  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.AccountHeadDropdown.filter(
      (option) => option.Account_Name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  displayFn(account: any): string {
    return account && account.Account_Name ? account.Account_Name : "";
  }
  getAccounthead() {
    this.lmsService.Get_Account_Master({}).subscribe((res: any) => {
      this.AccountHeadDropdown = res;

      //for (var i = 0; i < res.length; i++) {
      //  this.chargesHeadDropdown.push({ id: res[i]["AccountId"], name: res[i]["Account_Name"]});
      //}
      this.filteredAccountHead = this.AccountControl.valueChanges.pipe(
        startWith(""),
        map((value) =>
          typeof value === "string" ? value : value.Account_Name
        ),
        map((name) =>
          name ? this._filter(name) : this.AccountHeadDropdown.slice()
        )
      );
    });
  }


  getChargeshead() {
    this._MasterService
      .GetProductChargesHeadDropDown()
      .subscribe((res: any) => {
        this.chargesHeadDropdown = res;
      });
  }
  // getBranchesList() {
  //   if(this.BalanceType == 0) {
  //     this.lmsService
  //       .GetBranches({ Emp_Id: this.currentUser.userId })
  //       .subscribe((result) => {
  //         this.BranchesList = JSON.parse(JSON.stringify(result));
  //       });
  //   }
  // }
  onSearchAccountStatement(Addmore: boolean) {
    if (this.AccountHead != null) {
      this.showSpinner = true;
      if (this.BalanceType == 0) {
        this.dataSourceMonthly = "";
        this.dataSourceDaily = "";
        this.lmsService
          .Get_ACC_Leadger_Detail({
            AccountId: this.AccountHead,
            From: this.VoucherDateFrom,
            To: this.VoucherDateTo,
            StartYear: this.minDate.getFullYear()
          })
          .subscribe((res: any) => {
            console.log(res);
            if (res.length > 0) {
              this.displayRows = [];
              this.dataSource = new MatTableDataSource(this.displayRows);


              this.FileCheckingList = JSON.parse(JSON.stringify(res));
              this.voucherTree = this.buildVoucherTree(res);
              this.buildDisplayRows();


              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;

              setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip();
              }, 100);
              this.showSpinner = false;
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "No data found",
                ...this.configSuccess,
              });
              this.showSpinner = false;
            }
          });
      } else if (this.BalanceType == 1) {
        this.dataSource = "";
        this.dataSourceDaily = "";
        this.GetACCLeadgerByMonthly();
      } else {
        this.dataSource = "";
        this.dataSourceMonthly = "";
        this.GetACCLeadgerByDaily();
      }
    }
  }
  GetACCLeadgerByMonthly() {
    this.FileCheckingList = [];
    this.showSpinner = true;
    this.reportsService
      .Report_ACC_Leadger_By_Monthly({
        AccountId: this.AccountHead,
        From: this.VoucherDateFrom,
        To: this.VoucherDateTo,
        StartYear: this.minDate.getFullYear(),
      })
      .subscribe((res: any) => {
        //console.log("Resd :" ,res);
        if (res.length > 0) {
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          this.dataSourceMonthly = new MatTableDataSource(
            this.FileCheckingList
          );
          //this.dataSourceMonthly.sort = this.sort;
          //this.dataSourceMonthly.paginator = this.paginator;
          this.showSpinner = false;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
        }
      });
  }
  GetACCLeadgerByDaily() {
    this.FileCheckingList = [];
    this.showSpinner = true;
    this.reportsService
      .Report_ACC_Leadger_By_Daily({
        AccountId: this.AccountHead,
        From: this.VoucherDateFrom,
        To: this.VoucherDateTo,
        StartYear: this.minDate.getFullYear(),
      })
      .subscribe((res: any) => {
        //console.log("Resd :" ,res);
        if (res.length > 0) {
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          this.dataSourceDaily = new MatTableDataSource(this.FileCheckingList);
          //this.dataSourceDaily.sort = this.sort;
          //this.dataSourceDaily.paginator = this.paginator;
          this.showSpinner = false;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
        }
      });
  }

  LoadMore() {
    this.onSearchAccountStatement(true);
  }

  OnCloseVoucherDetail() {
    $("#VoucherDetail").modal("hide");
  }
  getTotalCalculation() {
    let _total: any = 0;
    let _totalCR: any = 0;
    let _totalTX: any = 0;
    this.voucherModel.Voucher_Detail.forEach((obj: any) => {
      _total = _total + obj.Amount || 0;
      _totalCR = _totalCR + obj.Amount || 0;
      obj.TaxSlab.forEach((tobj: any) => {
        _total = _total + tobj.TaxAmount || 0;
        _totalTX = _totalTX + tobj.TaxAmount || 0;
      });
    });
    this.totalCalculator = {
      total: Number(_total),
      totalCR: Number(_totalCR),
      totaltax: Number(_totalTX),
      totalInWord: new ToWords().convert(Number(_total)),
    };
  }

  // goToDetailModel(row) {
  //   this.FileCheckingList = [];
  //   this.dataSourceModel = "";

  //   var firstDayOfMonth, lastDayOfMonth, RowIndex, DayMonth;

  //   if (this.BalanceType == 1) {
  //     RowIndex = this.dataSourceMonthly.data.indexOf(row, 0);
  //     // if(RowIndex == 1){
  //     //   firstDayOfMonth = this.VoucherDateFrom;
  //     //   lastDayOfMonth  = new Date(this.VoucherDateFrom.getFullYear(), this.VoucherDateFrom.getMonth()+1, 0);
  //     // }
  //     // else{
  //     DayMonth = new Date(row.Month_Year);
  //     firstDayOfMonth = new Date(
  //       DayMonth.getFullYear(),
  //       DayMonth.getMonth(),
  //       1
  //     );
  //     lastDayOfMonth = new Date(
  //       DayMonth.getFullYear(),
  //       DayMonth.getMonth() + 1,
  //       0
  //     );
  //     if (lastDayOfMonth > this.VoucherDateTo) lastDayOfMonth = this.VoucherDateTo;
  //     //}
  //   } else {
  //     firstDayOfMonth = row.Voucher_Date;
  //     lastDayOfMonth = row.Voucher_Date;
  //   }

  //   //console.log("firstDayOfMonth", firstDayOfMonth, "----- lastDayOfMonth", lastDayOfMonth);
  //   this.showSpinner = true;
  //   this.lmsService
  //     .Get_ACC_Leadger_Detail({
  //       AccountId: row.AccountId,
  //       From: firstDayOfMonth,
  //       To: lastDayOfMonth,
  //       StartYear: this.minDate.getFullYear(),
  //     })
  //     .subscribe((res: any) => {
  //       $("#VoucherModel").modal("show");
  //       $("#VoucherModel").css("z-index", "1050");
  //       console.log(res);
  //       this.displayRows = [];
  //             this.dataSourceModel = new MatTableDataSource(this.displayRows);
  //       this.FileCheckingList = JSON.parse(JSON.stringify(res));
  //       this.voucherTree = this.buildVoucherTree(res);
  //             this.buildDisplayRows();
  //       // this.dataSourceModel = new MatTableDataSource(this.FileCheckingList);
  //       this.dataSourceModel.sort = this.sort;
  //       this.dataSourceModel.paginator = this.Paginglist;
  //       setTimeout(() => {
  //         $('[data-toggle="tooltip"]').tooltip();
  //       }, 100);
  //       this.showSpinner = false;
  //     });
  // }
  // ...existing code...
  goToDetailModel(row) {
    this.FileCheckingList = [];
    this.dataSourceModel = "";

    var firstDayOfMonth, lastDayOfMonth, RowIndex, DayMonth;

    if (this.BalanceType == 1) {
      RowIndex = this.dataSourceMonthly.data.indexOf(row, 0);
      DayMonth = new Date(row.Month_Year);
      firstDayOfMonth = new Date(
        DayMonth.getFullYear(),
        DayMonth.getMonth(),
        1
      );
      lastDayOfMonth = new Date(
        DayMonth.getFullYear(),
        DayMonth.getMonth() + 1,
        0
      );
      if (lastDayOfMonth > this.VoucherDateTo) lastDayOfMonth = this.VoucherDateTo;
    } else {
      firstDayOfMonth = row.Voucher_Date;
      lastDayOfMonth = row.Voucher_Date;
    }

    this.showSpinner = true;
    this.lmsService
      .Get_ACC_Leadger_Detail({
        AccountId: row.AccountId,
        From: firstDayOfMonth,
        To: lastDayOfMonth,
        StartYear: this.minDate.getFullYear(),
      })
      .subscribe((res: any) => {
        $("#VoucherModel").modal("show");
        $("#VoucherModel").css("z-index", "1050");
        console.log(res);

        // create an isolated data source for the detail modal
        this.dataSourceModel = new MatTableDataSource([]);

        this.FileCheckingList = JSON.parse(JSON.stringify(res));
        // build a voucher tree from the fetched rows (reusing existing function)
        // this.voucherTree = this.buildVoucherTree(res);
        //  const modalTree = this.buildVoucherTree(res);
        this.modalTree = this.buildVoucherTree(res);

        this.buildDisplayRows(this.dataSourceModel, this.modalTree);

        this.dataSourceModel.sort = this.sort;
        this.dataSourceModel.paginator = this.Paginglist;
        setTimeout(() => {
          $('[data-toggle="tooltip"]').tooltip();
        }, 100);
        this.showSpinner = false;
      });
  }
  // ...existing code...
  OnCloseVoucherModel() {
    $("#VoucherModel").modal("hide");
  }

  onChangeChargesHead(data: any, dindex: any) {
    data.Amount = "";
    data.TaxSlab = [];
    this.lmsService
      .Get_AccountHead_For_VoucherEntry({
        HeadId: data.ChargeHeadId,
        VoucherSubType: this.voucherModel.Voucher.Voucher_Sub_Type,
        ProductId: data.ProductId || 0,
        TaxType: data.TranType,
      })
      .subscribe((res: any) => {
        if (res.Item1[0]) {
          if (res.Item1[0].AccountId) {
            data.AccountId = res.Item1[0].AccountId;
            data.ChargeHeadCategory = res.Item1[0].AccountName;
            data.TaxSlab = res.Item2;
          } else {
            data.ChargeHeadId = "";
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "category does not have account head.",
              ...this.configSuccess,
            });
          }
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data Found.",
            ...this.configSuccess,
          });
        }
      });
  }
  onVoucherTagChange() {
    this.Get_Acc_Accounts_By_Tag();
  }
  Get_Acc_Accounts_By_Tag() {
    this.voucherModel.Voucher.DRAccountId = "";
    if (this.voucherModel.Voucher.Voucher_Tag == null)
      this.voucherModel.Voucher.Voucher_Tag = "CASH";
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        Account_Tag: this.voucherModel.Voucher.Voucher_Tag,
        Voucher_Date: new Date(this.voucherModel.Voucher.Voucher_Date),
      })
      .subscribe((res: any) => {
        this.accountTagDropdown = res;
      });
  }
  calculateTranTypeCR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateTranTypeDR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  // calculateACTranTypeDR() {
  //   if (this.dataSource != null && this.dataSource != "") {
  //     let sum = 0.0;
  //     for (let i = 0; i < this.dataSource.filteredData.length; i++) {
  //       sum += Number(this.dataSource.filteredData[i]["TranTypeDR"]);
  //     }
  //     return sum.toFixed(2);
  //   }
  //   return 0;
  // }
  calculateACTranTypeDR() {
    if (this.dataSource != null && this.dataSource != "") {
      let sum = 0.0;
      // only sum main/parent rows if isParent flag exists
      const rows = this.dataSource.filteredData;
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];
        if (r.hasOwnProperty('isParent')) {
          if (r.isParent) sum += Number(r.TranTypeDR || 0);
        } else {
          // fallback for older data shape
          sum += Number(r.TranTypeDR || 0);
        }
      }
      return sum.toFixed(2);
    }
    return "0.00";
  }
  // calculateACTranTypeCR() {
  //   if (this.dataSource != null && this.dataSource != "") {
  //     let sum = 0.0;
  //     for (let i = 0; i < this.dataSource.filteredData.length; i++) {
  //       sum += Number(this.dataSource.filteredData[i]["TranTypeCR"]);
  //     }
  //     return sum.toFixed(2);
  //   }
  //   return 0;
  // }
  calculateACTranTypeCR() {
    if (this.dataSource != null && this.dataSource != "") {
      let sum = 0.0;
      const rows = this.dataSource.filteredData;
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];
        if (r.hasOwnProperty('isParent')) {
          if (r.isParent) sum += Number(r.TranTypeCR || 0);
        } else {
          sum += Number(r.TranTypeCR || 0);
        }
      }
      return sum.toFixed(2);
    }
    return "0.00";
  }

  calculateACTranTypeTotal() {
    if (this.dataSource != null && this.dataSource != "") {
      /*let sum = 0;
      let DR = this.calculateACTranTypeDR()
      let CR = this.calculateACTranTypeCR();
      sum = Number(DR) - Number(CR);
      if (sum > 0)
        return sum.toFixed(2).toString() + " DR"
      else
        //return sum.toFixed(2).toString().split('-')[1] + " CR"
        return sum.toFixed(2).toString().split('-')[1] != undefined ? sum.toFixed(2).toString().split('-')[1] + " CR" : 0.00;*/
      var lastBalance = this.dataSource.filteredData.at(-1).TranTypeTotal;
      return lastBalance;
    }
    return 0;
  }

  totaltypeDaily(type) {
    if (this.dataSourceDaily != null && this.dataSourceDaily != "") {
      let sum = 0;
      for (let i = 0; i < this.dataSourceDaily.filteredData.length; i++) {
        sum += Number(this.dataSourceDaily.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : "";
    }
    return 0;
  }
  totaltypeMonthly(type) {
    if (this.dataSourceMonthly != null && this.dataSourceMonthly != "") {
      let sum = 0;
      for (let i = 0; i < this.dataSourceMonthly.filteredData.length; i++) {
        sum += Number(this.dataSourceMonthly.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : "";
    }
    return 0;
  }

  // totaltypeModel(type) {
  //   if (this.dataSourceModel != null && this.dataSourceModel != "") {
  //     let sum = 0;
  //     for (let i = 0; i < this.dataSourceModel.filteredData.length; i++) {
  //       sum += Number(this.dataSourceModel.filteredData[i][type]);
  //     }
  //     return sum > 0 ? sum.toFixed(2) : "";
  //   }
  //   return 0;
  // }
  totaltypeModel(type: string) {
    if (this.dataSourceModel != null && this.dataSourceModel !== "") {
      let sum = 0.0;
      const rows = this.dataSourceModel.filteredData;

      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];

        if (r.hasOwnProperty('isParent')) {
          if (r.isParent) sum += Number(r[type] || 0);
        } else {
          sum += Number(r[type] || 0);
        }
      }

      return sum.toFixed(2);
    }

    return "0.00";
  }

  totaltypeModelBal() {
    if (this.dataSourceModel != null && this.dataSourceModel != "") {
      var lastBalance = this.dataSourceModel.filteredData.at(-1).TranTypeTotal;
      return lastBalance;
    }
    return 0;
  }
  //   totaltypeModelBal() {
  //   if (this.dataSourceModel != null && this.dataSourceModel !== "") {
  //     const rows = this.dataSourceModel.filteredData;

  //     // Get last parent row (ignore child rows)
  //     for (let i = rows.length - 1; i >= 0; i--) {
  //       const r = rows[i];

  //       if (!r.hasOwnProperty('isParent') || r.isParent) {
  //         return Number(r.TranTypeTotal || 0).toFixed(2);
  //       }
  //     }
  //   }

  //   return "0.00";
  // }

  calculateMonthlyBalance() {
    if (this.dataSourceMonthly != null && this.dataSourceMonthly != "") {
      var lastBalance = this.dataSourceMonthly.filteredData.at(-1).Balance;

      // Check if balance is greater than 0 or less than 0 and append DR or CR
      if (lastBalance > 0) {
        return lastBalance + " DR";
      } else if (lastBalance < 0) {
        return lastBalance + " CR";
      }
      return lastBalance; // No DR or CR if the balance is 0
    }
    return 0; // Return 0 if dataSourceMonthly is null or empty
  }

  calculateDailyBalance() {
    if (this.dataSourceDaily != null && this.dataSourceDaily != "") {
      var lastBalance = this.dataSourceDaily.filteredData.at(-1).Balance;

      if (lastBalance > 0) {
        return lastBalance + " DR";
      } else if (lastBalance < 0) {
        return lastBalance + " CR";
      }
      return lastBalance;
    }
    return 0;
  }

  // calculateDailyBalance() {
  //   if (this.dataSourceDaily != null && this.dataSourceDaily != "") {
  //     var lastBalance = this.dataSourceDaily.filteredData.at(-1).Balance;
  //     return lastBalance;
  //   }
  //   return 0;
  // }

  DeleteVoucher() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to remove this Voucher.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.lmsService
            .Delete_Voucher({
              VoucherId: this.voucherModel.Voucher.VoucherId,
              LoginUserId: this.currentUser.userId,
            })
            .subscribe((res: any) => {
              if (res[0].CODE == 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                if (
                  this.voucherModel.Voucher_Detail.find((obj: any) => {
                    return obj.ChargeHeadId == 34;
                  })
                )
                  this.lmsService
                    .LMS_Update_EMI_Allocation({
                      VoucherId: this.voucherModel.Voucher.VoucherId,
                    })
                    .subscribe((res1: any) => { });
                this.OnCloseVoucherDetail();
                this.onSearchAccountStatement(false);
              }
            });
        }
      });
  }

  onCloseAccountStatementPrintModel() {
    $("#AccountStatementPrintModel").modal("hide");
  }

  printdata() {
    $("#AccountStatementPrintModel").modal("show");
    $("#AccountStatementPrintModel").css("z-index", "1050");
  }

  printConfirmation() {
    $("#AccountStatementConfirmationPrintModel").modal("show");
    $("#AccountStatementConfirmationPrintModel").css("z-index", "1050");
  }

  onCloseAccountStatementConfirmationPrintModel() {
    $("#AccountStatementConfirmationPrintModel").modal("hide");
  }

  DateChange() {
    if (this.VoucherDateFrom > this.VoucherDateTo) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "VoucherDate To greater than VoucherDate From.",
        ...this.configSuccess,
      });
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.VoucherDateFrom = new Date(
            moment(res[0].fystart).format("MM/DD/YYYY")
          );
          this.VoucherDateTo = new Date();
        });
    }
  }
  GetData(data) {
    if (data == true) {
      this.onSearchAccountStatement(false);
    }
  }

  datePipe: DatePipe = new DatePipe("en-US");

  onPrint(divName, type) {
    var File_Name;
    // File_Name = type == 1 ? 'Accounting-statement.pdf' : 'SOA.pdf';
    this.HiddenContent = true;
    let DATA: any = document.getElementById(divName);
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      canvas.getContext("webgl");
      const FILEURI = canvas.toDataURL("image/jpg");
      let PDF = new jsPDF("p", "mm", "a4");
      let position = 30;

      var pageHeight = PDF.internal.pageSize.getHeight();
      var pagecount = Math.ceil(fileHeight / pageHeight);
      //console.log(pagecount);
      PDF.addImage(FILEURI, "JPEG", 1, position, fileWidth, 0);

      if (pagecount > 0) {
        var j = 1;
        while (j != pagecount) {
          PDF.addPage("p");
          PDF.addImage(FILEURI, "JPEG", 2, -(j * pageHeight), fileWidth - 4, 0);
          j++;
        }
      }

      PDF.setFontSize(8);
      PDF.setTextColor(33, 37, 41);
      PDF.text(this.currentUser.CompanyName, 3, 20);
      PDF.text("Printed By : " + this.currentUser.username, 3, 285);
      PDF.text(
        "Printed On : " +
        this.datePipe.transform(new Date(), "dd/MM/yyyy hh:mm:ss"),
        160,
        285
      );
      // PDF.save(File_Name);
    });
  }
  onDocsPrint(divName, Header) {
    this._commonfunctions.PrintDocuments(divName, Header, "");
  }

  // Excel export in backend start here
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      excelFileName + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  exportExcel() {
    this.showSpinner = true;
    this.lmsService
      .Get_Acc_Leadger({
        AccountId: this.AccountHead,
        From: this.VoucherDateFrom,
        To: this.VoucherDateTo,
        StartYear: this.minDate.getFullYear(),
      })
      .subscribe((res: any) => {
        console.log("RES", res);
        //remove or hide a key & value of an array
        res.forEach(function (item) {
          delete item["voucherid"];
          delete item["ChagesHead"];
          delete item["Voucher_Type"];
          delete item["Customer_Name"];
          delete item["HeadId"];
          delete item["DaysLate"];
          delete item["ODInterest"];
          delete item["ODCredit"];
          delete item["ODTotal"];
          delete item["Balance"];
          delete item["Voucher_Cheque_Clear_Date"];
          delete item["Receipt_No"];

          item.TotalBalance = item.TranTypeTotal;

          delete item.TranTypeTotal;
        });

        res.push({
          VoucherDate: "",
          Voucher_No: "",
          CaseNo: "",
          accHead: "Total",
          TranTypeDR: this.calculateACTranTypeDR(),
          TranTypeCR: this.calculateACTranTypeCR(),
          TotalBalance: this.calculateACTranTypeTotal(),
          Narration: "",
          Reference_No: "",
        });
        this.exportAsExcelFile(res, "Accounting Statement");
        this.showSpinner = false;
      });
  }
  exportTableMonthly(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "accounting_statement_monthly"
    ) as HTMLTableElement;
    const worksheetName = "ACCOUNTING STATEMENT MONTHLY"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
  exportTabledaily(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "accounting_statement_daily"
    ) as HTMLTableElement;
    const worksheetName = "ACCOUNTING STATEMENT DAILY"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
  exportTableDetails(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "accounting_statement_details"
    ) as HTMLTableElement;
    const worksheetName = "ACCOUNTING STATEMENT DETAILS"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  applyFilterMonthly(filterValue: String) {
    // dataSourceMonthly
    this.dataSourceMonthly.filter = filterValue.trim().toLowerCase();
  }

  applyFilterAnnually(filterValue: String) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterDaily(filterValue: String) {
    this.dataSourceDaily.filter = filterValue.trim().toLowerCase();
  }

  private buildVoucherTree(rows: any[]) {
    this.parentRowCache.clear();
    this.childRowCache.clear();
    const map: Record<string, any> = {};

    for (const r of rows) {
      // const key = r.Voucher_No ?? String(r.voucherid ?? '');
      const key = `VID:${r.voucherid}`;


      if (!map[key]) {
        map[key] = {
          // Voucher_No: key,
          // VoucherDate: r.VoucherDate,
          // VoucherId: r.voucherid,
          _key: key,
          Voucher_No: r.Voucher_No,
          VoucherDate: r.VoucherDate,
          VoucherId: r.voucherid,
          parent: null,
          children: [],
          expanded: false,
          expandable: false,
        };
      }

      // ✅ Parent = selected AccountHead row
      // if (Number(r.AccountId) === Number(this.AccountHead)) {
      //   map[key].parent = r;
      // } else {
      //   map[key].children.push(r);
      // }

      if (r.parent == 1) {
        map[key].parent = r;
      } else {
        map[key].children.push(r);
      }
    }

    // Post-process
    Object.values(map).forEach((node: any) => {
      // fallback: if no matching account, first row becomes parent
      if (!node.parent && node.children.length) {
        node.parent = node.children.shift();
      }

      node.expandable = node.children.length > 1;
    });

    // ✅ Sort vouchers by date
    return Object.values(map).sort(
      (a: any, b: any) =>
        new Date(a.VoucherDate).getTime() -
        new Date(b.VoucherDate).getTime()
    );
  }
  private parentRowCache = new Map<string, any>();
  private childRowCache = new Map<string, any>();


  private buildDisplayRows(targetDataSource?: MatTableDataSource<any>, targetTree?: any[]) {

    const rows: any[] = [];

    // choose caches: use component caches for main table, local caches for a provided targetDataSource
    const parentCache = targetDataSource ? new Map<string, any>() : this.parentRowCache;
    const childCache = targetDataSource ? new Map<string, any>() : this.childRowCache;

    // this.voucherTree.forEach((node: any) => {
    const tree = targetTree ?? this.voucherTree;
    tree.forEach((node: any) => {
      if (!node.parent) return;

      const cacheKey = node._key;
      let parentRow = parentCache.get(cacheKey);
      if (!parentRow) {
        parentRow = {
          ...node.parent,
          _key: node._key,
          VoucherId: node.VoucherId,
          Voucher_No: node.Voucher_No || node.VoucherId,
          expandable: node.expandable,
          expanded: node.expanded,
          isParent: true,
        };
        parentCache.set(cacheKey, parentRow);
      } else {
        parentRow.expanded = node.expanded;
      }

      rows.push(parentRow);

      if (node.expanded) {
        node.children.forEach((c: any) => {
          const vKey = node._key;
          const key = `${vKey}-${c.AccountId}`;

          let childRow = childCache.get(key);
          if (!childRow) {
            childRow = {
              ...c,
              Voucher_No: node.Voucher_No,
              expandable: false,
              expanded: false,
              isParent: false,
            };
            childCache.set(key, childRow);
          }

          rows.push(childRow);
        });
      }
    });

    // if targetDataSource provided, write into it and do not mutate component caches/displayRows
    if (targetDataSource) {
      targetDataSource.data = rows;
    } else {
      this.displayRows = rows;
      // ensure dataSource exists
      if (!this.dataSource) this.dataSource = new MatTableDataSource([]);
      this.dataSource.data = rows;
    }
  }

  // toggleVoucherByNo(
  //   voucherNo: string,
  //   targetDataSource?: MatTableDataSource<any>,
  //   targetTree?: any[]
  // ) {
  //   const tree = targetTree ?? this.voucherTree;
  //   if (!tree) return;

  //   const node = tree.find(
  //     (v: any) =>
  //       v.Voucher_No === voucherNo ||
  //       v._key === voucherNo ||
  //       String(v.VoucherId) === String(voucherNo) ||
  //       String(v.VoucherId) === voucherNo
  //   );

  //   if (!node || !node.expandable) return;

  //   node.expanded = !node.expanded;
  //   this.buildDisplayRows(targetDataSource, tree);
  // }
  toggleVoucherByNo(
    voucherId: number | string,
    targetDataSource?: MatTableDataSource<any>,
    targetTree?: any[]
  ) {
    const tree = targetTree ?? this.voucherTree;
    if (!tree) return;

    const key = `VID:${voucherId}`;
    const node = tree.find((v: any) => v._key === key);

    if (!node || !node.expandable) return;

    node.expanded = !node.expanded;
    this.buildDisplayRows(targetDataSource, tree);
  }

  OnClickExpandAll(targetDataSource?: MatTableDataSource<any>, targetTree?: any[]) {
    this.ExpandBtn = false;
    this.CollaspeBtn = true;

    const tree = targetTree ?? this.voucherTree;
    if (!tree) return;

    tree.forEach((node: any) => {
      if (node.expandable) node.expanded = true;
    });

    this.buildDisplayRows(targetDataSource, tree);
  }

  OnClickCollaspeAll(targetDataSource?: MatTableDataSource<any>, targetTree?: any[]) {
    this.ExpandBtn = true;
    this.CollaspeBtn = false;

    const tree = targetTree ?? this.voucherTree;
    if (!tree) return;

    tree.forEach((node: any) => (node.expanded = false));

    this.buildDisplayRows(targetDataSource, tree);
  }
  // calcTotals(list: any[]) {
  //   let dr = 0,
  //     cr = 0;
  //   list.forEach((r) => {
  //     dr += Number(r.TranTypeDR || 0);
  //     cr += Number(r.TranTypeCR || 0);
  //   });
  //   return { dr: dr.toFixed(2), cr: cr.toFixed(2) };
  // }
  //   trackByRow(index: number, row: any) {
  //   // parent rows track by Voucher_No
  //   if (row.isParent) return `P-${row.Voucher_No}`;

  //   // child rows track by voucherid + account
  //   return `C-${row.voucherid}-${row.AccountId}`;
  // }
  trackByRow(index: number, row: any) {
    if (!row) return index;

    // const key =
    //   row._key ||
    //   (row.Voucher_No ? `VNO:${row.Voucher_No}` : `VID:${row.voucherid}`);
    const key = row._key || `VID:${row.voucherid}`;

    return row.isParent
      ? `P-${key}`
      : `C-${key}-${row.AccountId}`;
  }

  // private buildExportRows(tree?: any[]): any[] {
  //   const rows: any[] = [];
  //   const source = tree ?? this.voucherTree;

  //   source.forEach((node: any) => {
  //     if (!node.parent) return;

  //     // Parent always included
  //     rows.push({
  //       ...node.parent,
  //       Voucher_No: node.Voucher_No,
  //       isParent: true,
  //        expanded: true 
  //     });

  //     // ALL children included (expanded)
  //     node.children.forEach((c: any) => {
  //       rows.push({
  //         ...c,
  //         Voucher_No: node.Voucher_No,
  //         isParent: false,
  //       });
  //     });
  //   });

  //   return rows;
  // }
  private buildExportRows(tree?: any[]): any[] {
    const rows: any[] = [];
    const source = tree ?? this.voucherTree;

    source.forEach((node: any) => {
      if (!node.parent) return;

      // Parent always included
      rows.push({
        ...node.parent,
        Voucher_No: node.Voucher_No,
        isParent: true,
        expanded: node.expanded   // 👈 respect UI state
      });

      // Include children ONLY if expanded on UI
      if (node.expanded) {
        node.children.forEach((c: any) => {
          rows.push({
            ...c,
            Voucher_No: node.Voucher_No,
            isParent: false,
          });
        });
      }
    });

    return rows;
  }

  exportexcelAnnually(): void {
    // build export snapshot from main tree
    this.exportRows = this.buildExportRows();
    setTimeout(() => {
      this.exportExpandedTable("accounting_statement_annually", "ACCOUNTING STATEMENT ANNUALLY");
    }, 0);
  }

  exportexcelModel(): void {
    // build export snapshot for modal — prefer modalTree, fallback to dataSourceModel.data
    if (this.modalTree && this.modalTree.length) {
      this.exportRows = this.buildExportRows(this.modalTree);
    } else if (this.dataSourceModel && Array.isArray(this.dataSourceModel.data)) {
      // convert flat data to display shape (no grouping) when tree is not available
      this.exportRows = this.dataSourceModel.data.map((r: any) => ({ ...r }));
    } else {
      this.exportRows = [];
    }

    setTimeout(() => {
      this.exportExpandedTable("accounting_statement_details", "ACCOUNTING STATEMENT DETAILS");
    }, 0);
  }
  private exportExpandedTable(tableId: string, worksheetName: string): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template = `
  <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>{worksheet}</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
    </head>
    <body>
      <table border="1">{table}</table>
    </body>
  </html>`;

    const base64 = (s: string) => window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: any) => s.replace(/{(\w+)}/g, (_m, p) => c[p]);

    const table = document.getElementById(tableId) as HTMLTableElement;
    if (!table) return;

    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const link = document.createElement("a");
    link.href = uri + base64(format(template, ctx));
    link.download = worksheetName + ".xls";
    link.click();
  }
  getCellStyle(row: any, extra = '') {
    const base = row.isParent
      ? 'background-color:#6e99d5;font-weight:bold;'
      : 'background-color:#eef4ff;';
    return base + extra;
  }

}
